import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import useApi from "../../hooks/useApi";

import { useToast } from "../../store/ToastProvider/ToastProvider";

import CustomButton from "../../Components/CustomButton";
import RequestWizard from "../../Components/RequestWizard";
import StarRating from "../../Components/StarRating";
import Loader from "../../Components/Loader";
import CustomModal from "../../Components/CustomModal/CustomModal";

import { ReactComponent as Share } from "../../static/images/share.svg";
import { ReactComponent as UserIcon } from "../../static/images/user_profile.svg";
import { ReactComponent as FullStar } from "../../static/images/full_star.svg";

import "./style.scss";

const FindProviderDetails = () => {
  const { providerId } = useParams();

  const [provider, setProvider] = useState();
  const [isWizardOpen, setIsWizardOpen] = useState(false);

  const { get, loading } = useApi();

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { showToast } = useToast();

  const fetchProvider = async () => {
    try {
      const response = await get(`/Providers/${providerId}`);

      setProvider(response);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchProvider();
  }, []);

  const handleBookingRequest = () => {
    if (provider) {
      setIsWizardOpen(true);
    }
  };

  const handleWizardClose = () => {
    setIsWizardOpen(false);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(provider.profileDetailsUrl).then(() => {
      showToast({
        title: t("link_copied"),
        description: t("coach_profile_copied", { name: provider.name }),
      });
    });
  };

  const handleBack = () => {
    navigate(`/search-results?activity=${provider.activityName}`);
  };

  return (
    <div className="single-provider-card-container">
      <ul>
        <div className="single-provider-back-btn">
          <CustomButton color="black" onClick={() => handleBack()}>
            {t("go_back")}
          </CustomButton>
        </div>
        {provider && (
          <li key={provider.providerId}>
            <div className="card-info">
              <div className="card-image">
                <div>
                  {provider.profileUrl ? (
                    <img src={provider.profileUrl} alt={""} />
                  ) : (
                    <UserIcon />
                  )}
                </div>
              </div>
              <div className="card-name">
                <div>
                  <h4>{provider.name}</h4>
                </div>
                <div className="card-name-activity">
                  <span>{t(provider.activity)}</span>
                </div>
                {provider.avarageRating === null ? (
                  <div className="card-rating">
                    <FullStar />
                    <span>{t("new_on_skedy")}</span>{" "}
                  </div>
                ) : (
                  <div>
                    <StarRating rating={provider.avarageRating} />
                  </div>
                )}
              </div>

              <div
                className="card-share"
                onClick={(e) => {
                  handleCopyLink();
                }}
              >
                <Share />
              </div>
            </div>

            {provider.about && (
              <div className="card-about">
                <span className="text-sm text-gray-600">
                  {i18n.language === "ka" && provider.aboutGeorgian
                    ? provider.aboutGeorgian
                    : provider.about}
                </span>
              </div>
            )}

            <div className="card-avaliability">
              {provider.available ? (
                <span className="available">{t("available")}</span>
              ) : (
                <span className="busy">{t("busy")}</span>
              )}
            </div>
            <div className="card-location">
              <span>{provider?.address?.city},</span>
              <span>{provider?.address?.district}</span>
            </div>

            <div className="card-book-btn">
              <CustomButton
                onClick={(event) => handleBookingRequest(event, provider)}
                disabled={!provider.available}
              >
                {t("request_booking")}
              </CustomButton>
            </div>
          </li>
        )}
      </ul>
      <CustomModal open={isWizardOpen} onClose={() => setIsWizardOpen(false)}>
        <RequestWizard
          isOpen={true}
          onClose={handleWizardClose}
          coach={provider}
        />
      </CustomModal>
      {loading && <Loader />}
    </div>
  );
};

export default FindProviderDetails;
